import Vue from "vue";
import App from "./App.vue";
import router from "./router.js";
import store from "./store/store.js";
import Vuelidate from "vuelidate";
import VueMoment from "vue-moment";
import moment from "moment-timezone";
import VueQrcodeReader from "vue-qrcode-reader";
import LogRocket from 'logrocket';
import bootstrap from "bootstrap";
import "./plugins/element.js";
import "@/assets/css/base.css";
import "@/assets/css/formcard.css";
import "@/assets/css/mycard.css";
import "@/custom-components-test/global.css";
import VueGoodTablePlugin from 'vue-good-table';
import flatPickr from "flatpickr";
import "flatpickr/dist/flatpickr.css";
import "flatpickr/dist/themes/material_blue.css";
import 'vue-good-table/dist/vue-good-table.css'



// import { VuejsDatatableFactory } from 'vuejs-datatable';
// import { TColumnsDefinition } from "vuejs-datatable";

//import Vuetify from "vuetify"
//import 'vuetify/dist/vuetify.min.css'
import "./CKeditorCustom/ckeditor5/build/ckeditor.js";



//import * as Sentry from "@sentry/browser";
//import * as Integrations from "@sentry/integrations";
window.collect = require('collect.js')

Vue.use(VueMoment, { moment, VueQrcodeReader });
Vue.use(Vuelidate);
Vue.use(VueGoodTablePlugin);

//Vue.use(VuejsDatatableFactory);
//Vue.use(TColumnsDefinition);

//Vue.use(Vuetify)
Vue.config.productionTip = false;
Vue.prototype.$timeZone =
    Intl.DateTimeFormat().resolvedOptions().timeZone || "America/New_York";

export const EventBus = new Vue({
    // vuetify: new Vuetify(),
    // el: '#app',
    router,
    store,

    render: (h) => h(App),
}).$mount("#app");

//service worker registration: @yuklFavish - disabled by jacob@ as it makes errors
// if ("serviceWorker" in navigator) {
//   navigator.serviceWorker.Register("/serviceworker.js").then(function() {});
// }

//Sentry.init({
//  dsn: "https://d5f8bb48307b4257afc0a969d5f9edab@sentry.io/2654276",
//  integrations: [new Integrations.Vue({ Vue, attachProps: true })],
//});

LogRocket.init('8d4oqh/jobase-dev');